import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import UpdatePorschePaymentModuleForm, { type FormValues } from './UpdatePorschePaymentModuleForm';

type UpdatePorschePaymentModuleDrawerProps = {
    moduleId: string;
    initialValues: FormValues;
    visible: boolean;
    onClose: () => void;
};

const UpdatePorschePaymentModuleDrawer = ({
    moduleId,
    initialValues,
    visible,
    onClose,
}: UpdatePorschePaymentModuleDrawerProps) => {
    const { t } = useTranslation(['porschePaymentModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>
                        {t('porschePaymentModuleDetails:paymentModuleDrawer.cancelButton')}
                    </Button>
                    <Button form="updatePorschePaymentModule" htmlType="submit" type="primary">
                        {t('porschePaymentModuleDetails:paymentModuleDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('porschePaymentModuleDetails:paymentModuleDrawer.title.update')}
            visible={visible}
            destroyOnClose
        >
            <UpdatePorschePaymentModuleForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default UpdatePorschePaymentModuleDrawer;

export const useUpdatePorschePaymentModuleDrawer = (
    moduleId: string,
    initialValues: UpdatePorschePaymentModuleDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <UpdatePorschePaymentModuleDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
